import { createFileRoute } from '@tanstack/react-router';
import { OnboardingLayout } from '@/features/account/shell/OnboardingLayout';
import { onboardingLayoutSearchSchema } from '@/features/account/onboarding/shared/onboarding-search.schema';
import { ensureOnboardingProgressLoaded } from '@/features/account/onboarding/shared/ensure-onboarding-progress.loader';

export const Route = createFileRoute('/onboarding')({
  validateSearch: onboardingLayoutSearchSchema,
  component: OnboardingLayout,
  loader: ({ context }) => ensureOnboardingProgressLoaded(context),
});
